export const env = {
  DATA_PER_PAGE: 10,
};
